export default __webpack_public_path__ + "static/media/map-img@2x.3c880419.png";